import React from 'react';
import Dropzone from 'components/base/Dropzone';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import { Candidate, Props } from './uploadPreview.type';
import PreviewTable, { candidateTablecolumns } from './table/PreviewTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import useAdvanceTable from 'hooks/useAdvanceTable';

function UploadPreview({ jsonData, setJsonData, resetError }: Props) {
  const table = useAdvanceTable({
    data: jsonData as Candidate[],
    columns: candidateTablecolumns,
    pageSize: 10,
    pagination: true,
    sortable: true,
    selection: true
  });

  const handleChange = (files: File[]) => {
    resetError();
    const file = files[0];
    if (typeof file !== 'undefined') {
      const fileType = file.name.split('.').pop()?.toLowerCase();

      const reader = new FileReader();
      reader.onload = (event: ProgressEvent<FileReader>) => {
        const fileContent = event.target?.result;

        if (fileType === 'csv') {
          // Parse CSV file
          Papa.parse(fileContent as string, {
            header: true,
            skipEmptyLines: true,
            complete: result => {
              setJsonData(result.data);
            }
          });
        } else if (fileType === 'xlsx' || fileType === 'xls') {
          // Parse Excel file
          const workbook = XLSX.read(fileContent, { type: 'binary' });
          const sheetName = workbook.SheetNames[0];
          const sheetData = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName]
          );
          setJsonData(sheetData);
        } else {
          alert('Unsupported file format. Please upload a CSV or Excel file.');
        }
      };

      if (fileType === 'csv') {
        reader.readAsText(file);
      } else if (fileType === 'xlsx' || fileType === 'xls') {
        reader.readAsBinaryString(file);
      }
    }
  };
  return (
    <div>
      <div className="mb-5">
        <h4 className="mb-3">Upload here</h4>
        <Dropzone
          className="mb-3"
          accept={{
            'text/csv': ['.csv', '.xlsx', '.xls']
          }}
          onDrop={handleChange}
          onDelete={() => setJsonData([])}
        />
      </div>
      {Array.isArray(jsonData) && jsonData.length > 0 && (
        <div>
          <h4 className="mb-3">Preview</h4>
          <AdvanceTableProvider {...table}>
            <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis border-top border-bottom border-translucent position-relative top-1">
              <PreviewTable />
            </div>
          </AdvanceTableProvider>
        </div>
      )}
    </div>
  );
}

export default UploadPreview;
